import { render, staticRenderFns } from "./topicDetail.vue?vue&type=template&id=3f9e63d4&"
import script from "./topicDetail.vue?vue&type=script&lang=ts&"
export * from "./topicDetail.vue?vue&type=script&lang=ts&"
import style0 from "./topicDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports